

import React from 'react';
import { connect } from 'react-redux';
import ForgetPasswordComponent from './ForgetPasswordPage';
import ForgetPasswordOtpSentToNumber from './ForgetPasswordOtpSentToNumber';
import AnimationWrapper from '../../Utils/animationWrapper.js';
import ChangePasswordComponent from './ChangePasswordPage';

class RegisterPageRootComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            currentForgetPasswordPart: "forgetPassword",
        }
    }

    componentDidMount() {
       
    }

    changeCurrentForgetPasswordPart = (type) => {
        console.log("inside changeRegisterPart >>" + type);
        this.setState({
            currentForgetPasswordPart: type
        });
    }

    render() {
            return (
                <div>
                    <div id="toastPopup" className="animated slideInRight d-none"></div>
                    {this.componentContent()}
                </div>
            )
    }

    componentContent() {
            return (
                        <AnimationWrapper.switchTransition
                                switchTrigger={this.state.currentForgetPasswordPart}
                                triggerValueForChild0="forgetPassword"
                                triggerValueForChild1="changePassword"
                                triggerValueForChild2="forgetPasswordOtpSentToNumber"
                                classNames={{ enterActive: 'notransition', exitActive: 'notransition'}}
                                
                            >
                                <ForgetPasswordComponent changeCurrentForgetPasswordPartTo={this.changeCurrentForgetPasswordPart} />
                                <ChangePasswordComponent changeCurrentForgetPasswordPartTo={this.changeCurrentForgetPasswordPart} />
                                <ForgetPasswordOtpSentToNumber changeCurrentForgetPasswordPartTo={this.changeCurrentForgetPasswordPart} />
                            </AnimationWrapper.switchTransition>
            )
        
    }

    
}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales
    }
}
function mapDispatchToProps(dispatch) {
    return {
        
    }
}

const RegisterPageRootComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterPageRootComponent)


export default RegisterPageRootComponentContainer;